import { inject, Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import { HttpService } from './http.service';
import { UserModel } from '@models/user/user.model';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class UserService {
  private readonly usersApi = !environment.isFullOnline
    ? `${environment.caisseApiUrl}/users`
    : `${environment.caisseApiUrl}/v2/users`;
  private readonly httpService = inject(HttpService);

  getUserById(id: number): Observable<UserModel> {
    return this.httpService.get<UserModel>(`${this.usersApi}/${id}`);
  }

  searchUser(searchTerm: string): Observable<UserModel[]> {
    return this.httpService.get<UserModel[]>(`${this.usersApi}/search`, { identifier: searchTerm });
  }

  getUsers(): Observable<UserModel[]> {
    return this.httpService.get(this.usersApi);
  }

  toggleUser(userId: number, enable: boolean): Observable<UserModel> {
    const status = enable ? 'enable' : 'disable';
    return this.httpService.patch<UserModel>(`${this.usersApi}/${userId}/${status}`);
  }
}
